module.exports = __webpack_public_path__ + "fonts/Latinka-Thin.78491794.ttf";